export const GET_MESSAGES_FILTER = 'GET_MESSAGES_FILTER';
export const GET_MESSAGES_FILTER_SUCCESS = 'GET_MESSAGES_FILTER_SUCCESS';
export const GET_MESSAGES_FILTER_FAIL = 'GET_MESSAGES_FILTER_FAIL';

export const GET_MESSAGE_TYPE_FILTER = 'GET_MESSAGE_TYPE_FILTER';
export const GET_MESSAGE_TYPE_FILTER_SUCCESS = 'GET_MESSAGE_TYPE_FILTER_SUCCESS';
export const GET_MESSAGE_TYPE_FILTER_FAIL = 'GET_MESSAGE_TYPE_FILTER_FAIL';

export const GET_MESSAGES = 'GET_MESSAGES';
export const GET_MESSAGES_SUCCESS = 'GET_MESSAGES_SUCCESS';
export const GET_MESSAGES_FAIL = 'GET_MESSAGES_FAIL';

export const RESET_MESSAGES = 'RESET_MESSAGES';
export const RESET_MESSAGES_SUCCESS = 'RESET_MESSAGES_SUCCESS';
export const RESET_MESSAGES_FAIL = 'RESET_MESSAGES_FAIL';

export const GET_MESSAGE_XML = 'GET_MESSAGE_XML';
export const GET_MESSAGE_XML_SUCCESS = 'GET_MESSAGE_XML_SUCCESS';
export const GET_MESSAGE_XML_FAIL = 'GET_MESSAGE_XML_FAIL';

export const CLEAR_MESSAGES_FILTER = 'CLEAR_MESSAGES_FILTER';
